import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getPlainte, changePlainteStatus } from "../../services/admin.plaintes.service";
import { ArrowLeft, CheckCircle, Clock, Play, XCircle } from "lucide-react"; // Import des nouvelles icônes
import { useToast } from "../../context/ToastContext";
import PlainteDetailsView from "./PlainteDetailsView"; 

export default function PlainteDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { showToast } = useToast();
  
  const [plainte, setPlainte] = useState(null);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);

  const fetchDetails = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getPlainte(id);
      setPlainte(data);
    } catch (err) {
      showToast("Erreur lors du chargement des détails", "error");
    } finally {
      setLoading(false);
    }
  }, [id, showToast]);

  useEffect(() => {
    fetchDetails();
  }, [fetchDetails]);

  const handleStatusUpdate = async (newStatusId) => {
    if (!window.confirm(`Voulez-vous changer le statut de cette plainte ?`)) return;
    
    try {
      setActionLoading(true);
      await changePlainteStatus(id, newStatusId);
      showToast("Le statut a été mis à jour", "success");
      await fetchDetails(); 
    } catch (err) {
      showToast("Erreur lors de la mise à jour du statut", "error");
    } finally {
      setActionLoading(false);
    }
  };

  if (loading) return <div className="loaderContainer">Chargement...</div>;
  if (!plainte) return <div className="page">Plainte introuvable</div>;

  const currentStatus = plainte.id_status;

  return (
    <div className="page">
      <div className="pageHeaderActions">
        <button className="btnSecondary" onClick={() => navigate(-1)}>
          <ArrowLeft size={18} /> Liste des plaintes
        </button>

        <div className="adminActions" style={{ display: 'flex', gap: '10px' }}>
         
          {currentStatus === "S01" && (
            <button className="btnAssign" onClick={() => handleStatusUpdate("S02")} disabled={actionLoading}>
              <Play size={18} /> Traiter la plainte
            </button>
          )}

          {["S01", "S02"].includes(currentStatus) && (
            <button className="btnSuccess" onClick={() => handleStatusUpdate("S03")} disabled={actionLoading}>
              <CheckCircle size={18} /> Marquer comme terminée
            </button>
          )}

          {["S01", "S02"].includes(currentStatus) && (
            <button className="btnDanger" onClick={() => handleStatusUpdate("S04")} disabled={actionLoading}>
              <XCircle size={18} /> Annuler
            </button>
          )}

          {["S03", "S04"].includes(currentStatus) && (
            <button className="btnSecondary" onClick={() => handleStatusUpdate("S01")} disabled={actionLoading}>
              <Clock size={18} /> Réouvrir le ticket
            </button>
          )}
        </div>
      </div>

      <PlainteDetailsView tr={plainte} />
    </div>
  );
}